module.exports = __webpack_public_path__ + "static/p06_ocaJuego-e92cdf7e01fc61a43d9bc5e49c148811.png";